import { ReactElement } from 'react';

import { useBoolean } from '@dreryk/react-common';

import { ConsentTemplateModal } from './ConsentTemplateModal';

type ConsentTemplateModalOpenerRenderProps = { openModal: VoidFunction };
type ConsentTemplateModalOpenerProps = {
   readonly children: (renderProps: ConsentTemplateModalOpenerRenderProps) => ReactElement;
   readonly patientId: number;
   readonly visitId: number;
   readonly priorityTemplateIds: number[];
};

export const ConsentTemplateModalOpener = (props: ConsentTemplateModalOpenerProps): ReactElement => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean(false);
   return (
      <>
         {props.children({ openModal: openModal })}
         {modalOpened ? (
            <ConsentTemplateModal
               onClose={closeModal}
               patientId={props.patientId}
               visitId={props.visitId}
               priorityTemplateIds={props.priorityTemplateIds}
            />
         ) : null}
      </>
   );
};
